import { SIDEBAR_Z_INDEX } from 'app/constants/ZIndex';
import styled, { css, keyframes } from 'styled-components';

const newTagShimmer = keyframes`
  0% { background-position: -120% 0; }
  100% { background-position: 220% 0; }
`;

const newTagGlow = keyframes`
  0%, 100% {
    box-shadow: 0 0 0 1.5px rgba(255, 255, 255, 0.9),
      0 1px 5px rgba(233, 79, 14, 0.4);
  }
  50% {
    box-shadow: 0 0 0 1.5px rgba(255, 255, 255, 0.9),
      0 2px 12px rgba(233, 79, 14, 0.7);
  }
`;

export const NewTag = styled.div<{
  $variant: 'inline' | 'overlay';
  $shimmer?: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${(props) =>
    props.$variant === 'inline' ? 'var(--spacing-4, 4px)' : '0'};
  padding: var(--spacing-4, 4px);
  border-radius: ${(props) =>
    props.$variant === 'overlay'
      ? 'var(--radius-full, 999px)'
      : 'var(--radius-medium, 4px)'};
  background: var(--brand-secondary-secondary-lighter, #fdede7);

  color: var(--brand-secondary-secondary-main, #e94f0e);
  line-height: 1;

  ${(props) =>
    props.$variant === 'inline'
      ? `
    margin-left: auto;
  `
      : `
    z-index: ${SIDEBAR_Z_INDEX};
    width: 18px;
    height: 18px;
    pointer-events: none;
  `}

  svg {
    display: block;
    transform: none;
  }

  ${(props) =>
    props.$variant === 'inline'
      ? `
  span {
    font-family: var(--font-family-font-family-text, 'Noto Sans');
    font-size: var(--font-size-font-size-13, 13px);
    font-weight: 600;
    line-height: 1;
    color: var(--brand-secondary-secondary-main, #e94f0e);
    white-space: nowrap;
  }
  `
      : ''}

  ${(props) =>
    props.$shimmer
      ? css`
          position: relative;
          overflow: hidden;
          gap: 0;
          width: auto;
          height: auto;
          padding: 3px 7px;
          border-radius: 6px;
          border: none;
          background-color: #e94f0e;
          background-image: linear-gradient(
            100deg,
            #e94f0e 0%,
            #e94f0e 38%,
            #ffe3d1 50%,
            #e94f0e 62%,
            #e94f0e 100%
          );
          background-size: 220% 100%;
          animation: ${newTagShimmer} 2.2s linear infinite,
            ${newTagGlow} 2.4s ease-in-out infinite;

          span {
            position: relative;
            z-index: 1;
            font-family: var(--font-family-font-family-text, 'Noto Sans');
            font-size: 8.5px;
            font-weight: 600;
            line-height: 1;
            letter-spacing: 0.06em;
            text-transform: uppercase;
            color: #ffffff;
            white-space: nowrap;
            text-shadow: 0 1px 1px rgba(0, 0, 0, 0.12);
          }
        `
      : ''}
`;

export const NotificationTag = styled.div<{
  $variant: 'inline' | 'overlay';
  $isOverflowNotificationCount: boolean;
}>`
  display: inline-flex;
  align-items: center;
  justify-content: center;
  border-radius: ${(props) =>
    props.$variant === 'overlay'
      ? 'var(--radius-full, 999px)'
      : 'var(--radius-medium, 4px)'};
  background: var(--brand-primary-primary-light, #b3e6d8);
  color: var(--brand-primary-primary-darker, #01563f);
  line-height: 1;
  white-space: nowrap;

  ${(props) =>
    props.$variant === 'overlay'
      ? `
    z-index: ${SIDEBAR_Z_INDEX};
    width: ${props.$isOverflowNotificationCount ? '18px' : 'auto'};
    min-width: 18px;
    height: 18px;
    padding: ${props.$isOverflowNotificationCount ? '0' : '0 6px'};
    pointer-events: none;
    overflow: hidden;
  `
      : `
    margin-left: auto;
    width: ${props.$isOverflowNotificationCount ? '18px' : 'auto'};
    min-width: 18px;
    height: 18px;
    padding: ${props.$isOverflowNotificationCount ? '0' : 'var(--spacing-4, 4px)'};
  `}

  span {
    font-family: var(--font-family-font-family-text, 'Noto Sans');
    font-size: 10px;
    font-weight: 600;
    line-height: ${(props) => (props.$variant === 'overlay' ? '18px' : '1')};
    color: var(--brand-primary-primary-darker, #01563f);
    white-space: nowrap;
  }
`;
